export default __webpack_public_path__ + "static/media/timeline.91041dd4.jpg";